import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Link, TextField, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { SectionShell } from '../SectionShell/SectionShell';

interface JobRunDescriptionSectionProps {
  description: string;
  isDescriptionManuallyEdited: boolean;
  isComplete: boolean;
  arePreviousInputsFilled: boolean;
  onChange: (text: string) => void;
  onReset: () => void;
}

export const JobRunDescriptionSection = ({
  description,
  isDescriptionManuallyEdited,
  isComplete,
  arePreviousInputsFilled,
  onChange,
  onReset,
}: JobRunDescriptionSectionProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  return (
    <SectionShell
      stepNumber={4}
      title={formatMessage({ id: 'adminProjects.generateAccuracy.description.title' })}
      description={formatMessage({ id: 'adminProjects.generateAccuracy.description.description' })}
      isComplete={isComplete}
      isLast
    >
      <TextField
        fullWidth
        disabled={!arePreviousInputsFilled}
        value={description}
        onChange={(e) => onChange(e.target.value)}
        placeholder={
          !arePreviousInputsFilled
            ? formatMessage({
                id: 'adminProjects.generateAccuracy.description.completePrevStepsFirst',
              })
            : formatMessage({
                id: 'adminProjects.generateAccuracy.description.placeholder',
              })
        }
      />
      {arePreviousInputsFilled && isDescriptionManuallyEdited && (
        <Link
          component="button"
          underline="hover"
          onClick={onReset}
          sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, mt: theme.spacing(1) }}
        >
          <RestartAltIcon fontSize="small" />
          {formatMessage({ id: 'adminProjects.generateAccuracy.description.reset' })}
        </Link>
      )}
    </SectionShell>
  );
};
